import { Component, OnInit, Input, ContentChild } from '@angular/core';
import { BoxInfoContentDirective, BoxInfoFooterDirective, BoxInfoHeaderDirective } from './box-info.directive';
export class BoxInfoComponent implements OnInit {
public progressBarBg: string;
public backgroundColor: string;
public contentStyleClass = 'info-box-number';
public contentColor: string;
public footer: string;
public footerColor: string;
public footerStyleClass = 'progress-description';
public header: string;
public headerColor: string;
public headerStyleClass = 'info-box-text';
public iconBackgroundColor: string;
public iconColor = '#fff';
public iconStyleClass = 'ion ion-bag';
public progressWidth: number;
public styleClass = 'info-box';
public boxInfoHeaderDirective: BoxInfoHeaderDirective;
public boxInfoFooterDirective: BoxInfoFooterDirective;
public boxInfoContentDirective: BoxInfoContentDirective;
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit(){
    if(!this.backgroundColor) {
      this.progressBarBg = this.iconBackgroundColor;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-box-info',
  styles: [`
    .info-box.bg-color > .info-box-content {
      color: #fff;
    }
  `],
  template: `
    <div [ngClass]="styleClass" [mkColor]="backgroundColor" mkColorProperty="background-color">
      <span class="info-box-icon" [mkColor]="iconBackgroundColor" mkColorProperty="background-color">
        <i [ngClass]="iconStyleClass" [mkFontColor]="iconColor"></i>
      </span>
      <div class="info-box-content">
        <span *ngIf="header || boxInfoHeaderDirective" [ngClass]="headerStyleClass" [mkFontColor]="headerColor">
          {{header}}
          <ng-content select="mk-box-header"></ng-content>
        </span>
        <span [ngClass]="contentStyleClass" [mkFontColor]="contentColor">
          <ng-container *ngIf="boxInfoHeaderDirective || boxInfoContentDirective || boxInfoFooterDirective else noDirective">
            <ng-content select="mk-box-content"></ng-content>
          </ng-container>
          <ng-template #noDirective>
            <ng-content></ng-content>
          </ng-template>
        </span>
        <div *ngIf="progressWidth" class="progress">
          <div class="progress-bar" [mkColor]="progressBarBg" mkColorProperty="background-color" [style.width.%]="progressWidth"></div>
        </div>
        <span *ngIf="footer || boxInfoFooterDirective" [ngClass]="footerStyleClass" [mkFontColor]="footerColor">
          {{footer}}
          <ng-content select="mk-box-footer"></ng-content>
        </span>
      </div>
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'backgroundColor': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'contentColor': [{ type: Input },],
'footer': [{ type: Input },],
'footerColor': [{ type: Input },],
'footerStyleClass': [{ type: Input },],
'header': [{ type: Input },],
'headerColor': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'iconBackgroundColor': [{ type: Input },],
'iconColor': [{ type: Input },],
'iconStyleClass': [{ type: Input },],
'progressWidth': [{ type: Input },],
'styleClass': [{ type: Input },],
'boxInfoHeaderDirective': [{ type: ContentChild, args: [BoxInfoHeaderDirective, ] },],
'boxInfoFooterDirective': [{ type: ContentChild, args: [BoxInfoFooterDirective, ] },],
'boxInfoContentDirective': [{ type: ContentChild, args: [BoxInfoContentDirective, ] },],
};
}

function BoxInfoComponent_tsickle_Closure_declarations() {
/** @type {?} */
BoxInfoComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxInfoComponent.ctorParameters;
/** @type {?} */
BoxInfoComponent.propDecorators;
/** @type {?} */
BoxInfoComponent.prototype.progressBarBg;
/** @type {?} */
BoxInfoComponent.prototype.backgroundColor;
/** @type {?} */
BoxInfoComponent.prototype.contentStyleClass;
/** @type {?} */
BoxInfoComponent.prototype.contentColor;
/** @type {?} */
BoxInfoComponent.prototype.footer;
/** @type {?} */
BoxInfoComponent.prototype.footerColor;
/** @type {?} */
BoxInfoComponent.prototype.footerStyleClass;
/** @type {?} */
BoxInfoComponent.prototype.header;
/** @type {?} */
BoxInfoComponent.prototype.headerColor;
/** @type {?} */
BoxInfoComponent.prototype.headerStyleClass;
/** @type {?} */
BoxInfoComponent.prototype.iconBackgroundColor;
/** @type {?} */
BoxInfoComponent.prototype.iconColor;
/** @type {?} */
BoxInfoComponent.prototype.iconStyleClass;
/** @type {?} */
BoxInfoComponent.prototype.progressWidth;
/** @type {?} */
BoxInfoComponent.prototype.styleClass;
/** @type {?} */
BoxInfoComponent.prototype.boxInfoHeaderDirective;
/** @type {?} */
BoxInfoComponent.prototype.boxInfoFooterDirective;
/** @type {?} */
BoxInfoComponent.prototype.boxInfoContentDirective;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
